module.exports = {
  apiURL: process.env.REACT_APP_API_URL || 'https://api.gardentracker.app',
};
